<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="新增公司"></el-page-header>
        <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="form"
                 :style="{width: form_width,margin: '20px auto 0 auto'}" autocomplete="off">
            <el-form-item label="公司全称" prop="company_name">
                <el-input type="text" v-model="ruleForm.company_name" placeholder="请输入公司全称" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="公司简称" prop="short_name">
                <el-input type="text" v-model="ruleForm.short_name" placeholder="请输入公司简称" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>

            <el-form-item label="所属区域" prop="distinct_id">
                <el-cascader
                        v-model="ruleForm.distinct_id"
                        :options="allRegion" placeholder="请选择所属区域" style="width: 100%;"></el-cascader>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-radio-group v-model="ruleForm.status">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="2">停用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="是否置顶" prop="is_top">
                <el-radio-group v-model="ruleForm.is_top">
                    <el-radio :label="2">否</el-radio>
                    <el-radio :label="1">是</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    import env from "@/api/env";
    import {getUserInfos} from '@/utils/userInfos';
    import {check} from "@/utils/checkData";
    import {isMobile} from "@/api/order";

    export default {
        created() {
            if (isMobile()) {
                this.form_width = "100%"
            }
        },
        mounted() {
            this.createParams();
        },
        data() {
            return {
                allRegion: [],
                ruleForm: {
                    company_name: "",
                    short_name: "",
                    distinct_id: "",
                    is_top: 0,
                    status: 1,
                },
                rules: {
                    company_name: [
                        {required: true, message: "请输入公司全称", trigger: "blur"},
                    ],
                    short_name: [
                        {required: true, message: "请输入公司简称", trigger: "blur"},
                    ],
                    distinct_id: [
                        {required: true, message: "请选择所属区域", trigger: "blur"},
                    ],
                    is_top: [
                        {required: true, message: "请选择是否置顶", trigger: "blur"},
                    ],
                    status: [
                        {required: true, message: "请选择状态", trigger: "blur"},
                    ],

                },
                form_width: "40%",
            };
        },
        methods: {
            // 所有地区
            createParams() {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'allRegion',
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allRegion = res.data.data;
                });
            },

            // 返回上一页
            goBack() {
                window.history.go(-1);
                // window.close()
            },

            // 提交表单
            submitForm(formName) {
                let _that = this
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        let params = {
                            'servername': 'Ruyi_AdminOperateServices',
                            'method': 'createCompany',
                            'params': {
                                company_name: this.ruleForm.company_name,
                                short_name: this.ruleForm.short_name,
                                is_top: this.ruleForm.is_top,
                                status: this.ruleForm.status,
                                province_id: this.ruleForm.distinct_id[0],
                                city_id: this.ruleForm.distinct_id[1],
                                distinct_id: this.ruleForm.distinct_id[2],
                            }
                        };
                        this.$api.service(params).then(res => {
                            if (!check(res)) {
                                return;
                            }
                            this.$message({
                                type: "success",
                                message: '创建成功',
                                duration: 1500,
                                onClose: function () {
                                    // window.history.go(-1);
                                    _that.$router.push({
                                        name: "companyList",
                                        params: {}
                                    });
                                }
                            });
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: '请输入必填项'
                        });
                        return false;
                    }
                });
            },
        }

    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 316px;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }

    .avatar {
        width: 316px;
        height: 200px;
        display: block;
    }

    .editor {
        line-height: normal !important;
        height: 800px;
    }

    .ql-snow .ql-tooltip[data-mode=link]::before {
        content: "请输入链接地址:";
    }

    .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
        border-right: 0px;
        content: '保存';
        padding-right: 0px;
    }

    .ql-snow .ql-tooltip[data-mode=video]::before {
        content: "请输入视频地址:";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item::before {
        content: '14px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
        content: '10px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
        content: '18px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
        content: '32px';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item::before {
        content: '文本';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
        content: '标题1';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
        content: '标题2';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
        content: '标题3';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
        content: '标题4';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
        content: '标题5';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
        content: '标题6';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item::before {
        content: '标准字体';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
        content: '衬线字体';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
        content: '等宽字体';
    }
</style>
